module.exports = __webpack_public_path__ + "img/Group.57e6759c.png";